import API from '../../../../network/dashboardAPI';

export const fetchSupplierProductBySupplierID = async (supplier_id) => {
    try {
        if (!supplier_id) return { data: [], error: "Supplier ID is required" };
        const postData = { "supplier_id": supplier_id };
        const response = await API.getAdminSupplierProductBySupplierId(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching products:", error);
        return { products: [], error: error.message || "Failed to fetch products" };
    }
};

export const fetchSupplierProducts = async (page = 1, limit = 10, filters) => {
    try {
        const postData = { page, limit, filters };
        const response = await API.getSupplierProduct(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching warehouses:", error);
        return { data: [], error: error.message || "Failed to fetch warehouses" };
    }
};

export const updateEnableDisableSupplierProduct = async (id, is_available) => {
    try {
        const postData = { id, is_available };
        const response = await API.updateEnableDisableSupplierProduct(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching warehouses:", error);
        return { data: [], error: error.message || "Failed to fetch warehouses" };
    }
};